import { render, staticRenderFns } from "./jianjie.vue?vue&type=template&id=246a3574&scoped=true"
import script from "./jianjie.vue?vue&type=script&lang=js"
export * from "./jianjie.vue?vue&type=script&lang=js"
import style0 from "./jianjie.vue?vue&type=style&index=0&id=246a3574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246a3574",
  null
  
)

export default component.exports